import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {CatalogItemCard} from '../../../common/ui/CatalogItemCard';
import {Swiper} from '../../../common/ui/Swiper';
import {PriceWithFallback} from '../../../common/ui/PriceWithFallback';
import {Indicador} from '../../../ui';
import {AddHabitualToCartButton} from '../../../product/ui/AddHabitualToCartButton';
import {isSuccess} from '../../../common/domain/RemoteData.model';
import {fetchHabituales} from '../../catalog/infrastructure/CatalogService';
import {useComercialContext} from '../../../comercial/ComercialContext';
import {useCartContext} from '../../../cart/context/CartContext';

const Container = styled.div`
    display: flex;
    gap: 1.5rem;
    flex-direction: column;
`;

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

/**
 * Productos que el cliente compra de forma recurrente y toca reponer u olvidó.
 * Oculta los que ya estan en el carrito. Sin etiqueta de frecuencia por tarjeta:
 * negocio no quiere mostrar cada cuanto lo pide (29-oct-2026).
 */
export const HabitualProducts = () => {
    const [items, setItems] = useState([]);
    const {actingAsCliente} = useComercialContext();
    const {isOnCart} = useCartContext();
    const numCliente = actingAsCliente?.numCliente ?? null;

    useEffect(() => {
        let cancelled = false;
        setItems([]);
        fetchHabituales(numCliente).then((result) => {
            if (!cancelled && isSuccess(result) && Array.isArray(result.value)) {
                setItems(result.value);
            }
        });
        return () => { cancelled = true; };
    }, [numCliente]);

    const visibles = items.filter((item) => item?.product && !isOnCart(item.product.id));

    if (visibles.length === 0) {
        return null;
    }

    return (
        <Container>
            <Indicador indicador="Tus productos habituales" />
            {/* Carrusel como favoritos y destacados: en rejilla los 12 ocupaban dos filas. */}
            <Swiper>
                {visibles.map((item) => (
                    <Swiper.Item key={item.product.code}>
                        <CardWrapper>
                            <CatalogItemCard data={{ catalogItem: item.product }}>
                                <CatalogItemCard.Price>
                                    <PriceWithFallback data={{
                                        sellingPrice: item.product.price?.bestPrice,
                                        basePrice: item.product.price?.value
                                    }}/>
                                </CatalogItemCard.Price>
                            </CatalogItemCard>
                            <AddHabitualToCartButton product={item.product}/>
                        </CardWrapper>
                    </Swiper.Item>
                ))}
            </Swiper>
        </Container>
    );
};
